import { FloatingFormItem } from '@/components/_common';
import {
  useAccountReceivableObservationCreate,
  useAccountReceivableObservationUpdate,
} from '@/core/domain/financial/AccountReceivableObservation/AccountReceivableObservation.hooks';
import { AccountReceivableObservation } from '@/core/domain/financial/AccountReceivableObservation/AccountReceivableObservation.types';
import { Form, Input } from 'antd';
import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import React, { useEffect } from 'react';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  installmentReceivableId?: number;
  observationData?: AccountReceivableObservation;
}

const AccountReceivableObservationModal: React.FC<Props> = ({
  installmentReceivableId,
  observationData,
  ...props
}) => {
  const [form] = Form.useForm<{ observation: string }>();
  const observationWatch = Form.useWatch('observation', form);

  const { mutateAsync: create, isLoading: createLoading } =
    useAccountReceivableObservationCreate();
  const { mutateAsync: update, isLoading: editLoading } =
    useAccountReceivableObservationUpdate();

  const handleOk = async () => {
    const { observation } = await form.validateFields();

    if (!!observationData) {
      await update({ id: observationData.id, observation });
    } else if (installmentReceivableId) {
      await create({ observation, installmentReceivableId });
      form.resetFields();
    }

    props.onCancel();
  };

  useEffect(() => {
    form.setFieldValue('observation', observationData?.observation);
  }, [observationData]);

  return (
    <Modal
      {...props}
      title={`${!!observationData ? 'Editar' : 'Nova'} observação`}
      okText={!!observationData ? 'Salvar' : 'Adicionar'}
      okButtonProps={{
        disabled:
          !observationWatch?.length ||
          (!!observationData &&
            observationWatch === observationData?.observation),
      }}
      onOk={handleOk}
      width={600}
      confirmLoading={createLoading || editLoading}
    >
      <Form form={form}>
        <FloatingFormItem label="Observação" name="observation">
          <Input.TextArea rows={5} />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
};

export default AccountReceivableObservationModal;
